import React from 'react';
import { useFormContext } from 'react-hook-form';
import { AutocompleteField } from 'components/form';
import { TruckType } from '@trnsact/trnsact-shared-types';
import { convertEnumToSelectOptions } from 'utils/selectOptionsHelper';

import { DealSheetRulesFilters } from './index';

export const EquipmentType = () => {
  const { control } = useFormContext<DealSheetRulesFilters>();

  return (
    <AutocompleteField
      multiple
      size="small"
      control={control}
      name="EQUIPMENT_TYPE"
      disableCloseOnSelect
      options={convertEnumToSelectOptions(TruckType)}
      textFieldProps={{ variant: 'outlined', label: 'Equipment Type' }}
    />
  );
};
